module.exports = __webpack_public_path__ + "img/huiyuan.87d76df8.png";